import React from 'react';
export function SolutionSection() {
  const grades = ['1°', '2°', '3°', '4°', '5°', '6°'];
  const skills = ['Emociones', 'Autoestima', 'Identidad', 'Diversidad', 'Convivencia', 'Respeto', 'Autocuidado', 'Ciudadanía Digital', 'Resolución de conflictos', 'Buen trato'];
  const designFeatures = ['Consignas claras', 'Recursos visuales', 'Actividades breves y dinámicas', 'Espacios amplios para responder', 'Lenguaje accesible', 'Aplicación inmediata en el aula'];
  return <section className="py-10 px-4 bg-white" data-id="element-148" data-mp="3t851e8t02qho">
      <div className="max-w-4xl mx-auto text-center" data-id="element-149" data-mp="auxfqqi74cnm">
        <p className="text-[20px] font-black mb-2 text-[#EF5B4C]" data-id="element-150" data-mp="atmfh0nyln19">
          La solución:
        </p>
        <h2 className="text-2xl md:text-4xl font-black mb-6 text-gray-900 leading-tight" data-id="element-151" data-mp="5xe1hqlhzzvo">
          UN SISTEMA COMPLETO DE ESI PARA TODA LA PRIMARIA
        </h2>

        <p className="text-lg md:text-xl text-gray-700 mb-8 max-w-3xl mx-auto" data-id="element-152" data-mp="fujrswmafmuu">
          El <span className="font-bold" data-id="element-153" data-mp="36bdwkoenifq0">MEGAPACK ESI PRIMARIA</span> está
          organizado para acompañar a docentes de 1° a 6° grado mediante
          actividades listas para imprimir y trabajar durante todo el ciclo
          lectivo.
        </p>

        {/* ¿Cómo está organizado? */}
        <div className="bg-gray-50 rounded-2xl p-6 md:p-8 mb-8 border border-gray-100 shadow-sm text-left" data-id="element-154" data-mp="3kawt0jy3o2mh">
          <h3 className="text-xl md:text-2xl font-black text-gray-900 mb-5 text-center" data-id="element-155" data-mp="3pa9r60uf8w4d">
            📚 ¿Cómo está organizado?
          </h3>

          {/* Grados */}
          <div className="flex flex-wrap justify-center gap-2 mb-6" data-id="element-156" data-mp="2tvqalej1grp">
            {grades.map(g => <div key={g} className="bg-white border-2 border-[#16A99A] text-gray-900 font-black w-14 h-14 flex items-center justify-center rounded-xl shadow-sm text-lg" data-id="element-157" data-mp="6vh7uk20aj88">
                {g}
              </div>)}
          </div>

          <ul className="space-y-2 max-w-xl mx-auto text-base md:text-lg text-gray-800" data-id="element-158" data-mp="grbvjtl374hv">
            <li className="flex items-start gap-2" data-id="element-159" data-mp="2cuqc6ulf3nwj">
              <span className="text-green-500 font-bold" data-id="element-160" data-mp="27yrlh0cm9tsy">✅</span>
              <span data-id="element-161" data-mp="2mmmhaplx8ea9">Primer Ciclo completo</span>
            </li>
            <li className="flex items-start gap-2" data-id="element-162" data-mp="2mnxh6ec8x1w3">
              <span className="text-green-500 font-bold" data-id="element-163" data-mp="2hve3zihh08rt">✅</span>
              <span data-id="element-164" data-mp="2hu31dlzrh72a">Segundo Ciclo completo</span>
            </li>
            <li className="flex items-start gap-2" data-id="element-165" data-mp="2vlzt3oxipey5">
              <span className="text-green-500 font-bold" data-id="element-166" data-mp="2rlzb5ub7mlmc">✅</span>
              <span data-id="element-167" data-mp="2rlfpq3mcpf3k">Más de 250 actividades listas para imprimir</span>
            </li>
            <li className="flex items-start gap-2" data-id="element-168" data-mp="35kyqucgqvq6d">
              <span className="text-green-500 font-bold" data-id="element-169" data-mp="30lvudgetysa0">✅</span>
              <span data-id="element-170" data-mp="30kax3j14sv8g">Recursos organizados por temas</span>
            </li>
            <li className="flex items-start gap-2" data-id="element-171" data-mp="1b7zf4ufhjg4d">
              <span className="text-green-500 font-bold" data-id="element-172" data-mp="168mijhytauol">✅</span>
              <span data-id="element-173" data-mp="16ah3gwa32mso">Material para todo el año escolar</span>
            </li>
          </ul>
        </div>

        {/* Habilidades */}
        <div className="mb-8 text-left" data-id="element-174" data-mp="3mujfupiarmi5">
          <p className="text-lg md:text-xl font-bold text-gray-900 mb-4 text-center" data-id="element-175" data-mp="3mthspmo0b9k2">
            Cada ciclo trabaja temas fundamentales como:
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2 max-w-2xl mx-auto" data-id="element-176" data-mp="3d4q51qpzbbey">
            {skills.map(s => <div key={s} className="flex items-center gap-2 text-gray-800 text-base md:text-lg" data-id="element-177" data-mp="2z46wmihlq3c9">
                <span className="text-[#EF5B4C] font-bold" data-id="element-178" data-mp="341yppftzfvi1">✔</span>
                <span data-id="element-179" data-mp="2p8lqc85i2gwp">{s}</span>
              </div>)}
          </div>
        </div>

        {/* Diseño */}
        <div className="bg-[#FFF4F1] rounded-2xl p-6 md:p-8 mb-8 border border-[#FBD9D2] text-left" data-id="element-180" data-mp="2u6dqfpgat9bz">
          <p className="text-lg md:text-xl font-bold text-gray-900 mb-4 text-center" data-id="element-181" data-mp="ndl37g3jf918">
            Todo el material fue diseñado con:
          </p>
          <div className="flex flex-wrap justify-center gap-2" data-id="element-182" data-mp="2oi6tymthh3pq">
            {designFeatures.map(f => <span key={f} className="bg-white border border-[#FBD9D2] text-gray-800 px-3 py-1.5 rounded-full text-sm md:text-base font-medium shadow-sm" data-id="element-183" data-mp="2kg1z5krau11i">
                ✨ {f}
              </span>)}
          </div>
        </div>

        <p className="text-xl md:text-2xl font-black text-gray-900" data-id="element-184" data-mp="25jkokvqxoqg0">
          🖨️{' '}
          <span className="px-2 bg-white text-[#8F7DA6]" data-id="element-185" data-mp="20sksfspn2cek">
            Descargás, imprimís y trabajás.
          </span>
        </p>
      </div>
    </section>;
}